import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    backdropFilter: 'blur(4px)',
  },
  content: {
    padding: theme.spacing(3),
    textAlign: 'justify',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}))

export default useStyles
